"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FULL_ROUTES = exports.INTEGRATION_ROUTE = exports.DOMAIN_ROUTE = exports.CALENDAR_ROUTE = exports.FEATURE_GATE = exports.DEFAULT_DOMAIN = exports.UPGRADE_PRODUCT = exports.SPLASH_PAGE = exports.MEETINGS_SCREEN_NAME = exports.APP_NAME = void 0;

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var APP_NAME = 'settings';
exports.APP_NAME = APP_NAME;
var MEETINGS_SCREEN_NAME = 'meetings';
exports.MEETINGS_SCREEN_NAME = MEETINGS_SCREEN_NAME;
var SPLASH_PAGE = 'splash-page';
exports.SPLASH_PAGE = SPLASH_PAGE;
var UPGRADE_PRODUCT = 'sales-starter';
exports.UPGRADE_PRODUCT = UPGRADE_PRODUCT;
var DEFAULT_DOMAIN = 'app.hubspot.com';
exports.DEFAULT_DOMAIN = DEFAULT_DOMAIN;
var FEATURE_GATE = 'feature-gate';
exports.FEATURE_GATE = FEATURE_GATE;
var CALENDAR_ROUTE = 'calendar';
exports.CALENDAR_ROUTE = CALENDAR_ROUTE;
var DOMAIN_ROUTE = 'domain';
exports.DOMAIN_ROUTE = DOMAIN_ROUTE;
var INTEGRATION_ROUTE = 'integration';
exports.INTEGRATION_ROUTE = INTEGRATION_ROUTE;
var FULL_ROUTES = {
  INDEX: "sales/" + _UrlPathParams.MEETINGS,
  CALENDAR: "sales/" + _UrlPathParams.MEETINGS + "/" + CALENDAR_ROUTE,
  INTEGRATION: "sales/" + _UrlPathParams.MEETINGS + "/" + INTEGRATION_ROUTE,
  DOMAIN: "sales/" + _UrlPathParams.MEETINGS + "/" + DOMAIN_ROUTE
};
exports.FULL_ROUTES = FULL_ROUTES;